<template>
  <div class="group-tab-box">
    <div class="tab-box" v-show="visibleTabList.length > 1">
      <div class="tab-nav" ref="tabNav" :class="{'tab-nav-more': dropDownTabList.length > 0}">
        <span
          v-for="tab in visibleTabList"
          :key="tab.moduleGroupId"
          class="tab-item"
          :class="{'is-active': activeTab === tab.moduleGroupId}"
          @click="handleTabClick(tab.moduleGroupId)">
          {{ tab.moduleGroupName }}
        </span>
      </div>
      <div class="dropdown-box" v-show="dropDownTabList.length > 0">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" ref="elDropdownMenu">
            <el-dropdown-item
              v-for="hideTab in dropDownTabList"
              :key="hideTab.moduleGroupId"
              :command="hideTab.moduleGroupId">
              {{hideTab.moduleGroupName}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <MenuList :list="mergedLinks" @update="refresh" v-show="tabList.length > 0" />
    <div class="no-data" v-show="tabList.length === 0">
      <img src="./empty.png" alt="暂无数据">
      <p>暂无内容，请点击右上角【添加常用】</p>
    </div>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import { HOME_MENUS } from 'public/config'
  import { SVGREG, SVGPATH } from '@/layout/layout/conf'
  import MenuList from './menu-list.vue'
  import { fetchModule } from './fetch-module'
  const SVGTICK = (new Date()).toLocaleDateString().replace(/\//g, '')

  function getIcon (menu) {
    let icon = menu.icon
    if (icon.startsWith('https')) {
      return icon
    }
    return icon && SVGREG.test(icon)
      ? `${SVGPATH}${icon}?${SVGTICK}`
      : `${SVGPATH}/_MENU/${menu.$ptitle}.svg?${SVGTICK}`
  }

  export default {
    props: {
      mode: {
        type: String,
        default: 'home' // home: 首页, dialog: 弹窗
      }
    },
    name: 'CommonModuleList',
    components: { MenuList },
    data () {
      return {
        links: [],
        tabList: [],
        activeTab: '',
        visibleTabList: [],
        dropDownTabList: [],
        defaultModule: null
      }
    },
    computed: {
      menus () {
        return this.$store.getters.menus
      },
      reminds () {
        const remindMenus = this.$store.state.remindMenus
        return Object.keys(remindMenus).filter(key => remindMenus[key])
      },
      filterHomeLinks () {
        return this.formatLinkList(HOME_MENUS)
      },
      mergedLinks () {
        const reminds = [...this.reminds]
        return [...this.filterHomeLinks, ...this.links].map(item => {
          return {
            ...item,
            remindShow: reminds.includes(item.url)
          }
        })
      },
      curMenuGroup () {
        let curMenu = this.tabList.find(item => item.moduleGroupId === this.activeTab)
        if (!curMenu) {
          curMenu = {
            moduleGroupId: this.defaultModule ? this.defaultModule.moduleGroupId : '',
            moduleGroupName: this.defaultModule ? this.defaultModule.moduleGroupName : ''
          }
        }
        return {
          moduleGroupId: curMenu ? curMenu.moduleGroupId : '',
          moduleGroupName: curMenu ? curMenu.moduleGroupName : ''
        }
      }
    },
    watch: {
      tabList: {
        handler () {
          this.visibleTabList = cloneDeep(this.tabList)
          this.$nextTick(() => {
            this.updateTabListShow()
          })
        },
        immediate: true
      },
      curMenuGroup: {
        handler (val) {
          this.$emit('menu-group-change', val)
        },
        immediate: true,
        deep: true
      },
    },
    mounted () {
      if (this.mode === 'home') {
        this.$bus.$on('GLOABL_HOME_UPDATE_MENU', this.refresh)
      }
    },
    methods: {
      async init () {
        await this.initMenuList()
        this.onTabClick()
      },
      async refresh () {
        await this.initMenuList(true)
        this.onTabClick()
      },
      async initMenuList (force = false) {
        const res = await fetchModule(force)
        this.defaultModule = res.find(item => +item.defaultGroupFlag === 1)
        this.tabList = res
        const prevActiveTab = this.activeTab
        const tabExists = prevActiveTab && this.tabList.some(item => item.moduleGroupId === prevActiveTab)
        this.activeTab = tabExists ? prevActiveTab : (res[0] ? res[0].moduleGroupId : null)
        this.$emit('updateActiveTab', this.activeTab)
      },
      formatLinkList (list) {
        const menus = this.menus
        return [...list].filter(item => menus[item.url]).map(item => {
          const menu = menus[item.url]
          return {
            ...item,
            icon: getIcon(menu) || '',
            subSystem: menu.subSystem || '',
            title: menu.title || ''
          }
        })
      },
      handleTabClick (moduleGroupId) {
        this.activeTab = moduleGroupId
        this.onTabClick()
      },
      onTabClick () {
        if (!this.activeTab) {
          this.links = []
          return
        }
        const tab = this.tabList.find(item => item.moduleGroupId === this.activeTab)
        const { itemList = [] } = tab || {}
        this.links = this.formatLinkList(itemList)
      },
      handleCommand (command) {
        this.activeTab = command
        this.onTabClick()
      },
      updateTabListShow () {
        const tabEle = this.$refs.tabNav
        if (!tabEle) {
          return
        }
        const paddingWidth = 0
        const tabEleList = tabEle.querySelectorAll('.tab-item')
        if (!tabEleList.length || tabEle.scrollWidth + paddingWidth <= tabEle.offsetWidth) {
          return
        }
        let visibleIndex = 0
        let length = paddingWidth
        for (let i = 0; i < tabEleList.length; i++) {
          length += tabEleList[i].offsetWidth
          if (length > tabEle.offsetWidth) {
            break
          } else {
            visibleIndex = i
          }
        }
        this.visibleTabList = cloneDeep(this.tabList.filter((_, index) => index <= visibleIndex))
        this.dropDownTabList = cloneDeep(this.tabList.filter((_, index) => index > visibleIndex))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .group-tab-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    .no-data {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      img {
        width: 132px;
        height: 74px;
        margin-bottom: 12px;
      }
      p {
        color: #A09EBF;
        font-family: "Microsoft YaHei";
        font-style: Regular;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0px;
        text-align: left;
      }
    }
  }

  .tab-box {
    width: 100%;
    display: flex;
    .tab-nav {
      display: flex;
      flex: 1;
      overflow: hidden;
      gap: 24px;
      padding-bottom: 6px;
      border-bottom: 1px solid rgba(224, 223, 239, 0.6);
      &-more {
        flex: none;
        width: calc(100% - 60px);
      }
      .tab-item {
        position: relative;
        flex-shrink: 0;
        font-size: 13px;
        color: #1D1C23;
        line-height: 30px;
        height: 30px; // 36px
        cursor: pointer;
        box-sizing: border-box;
        transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        &::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -6px;
          height: 2px;
          background-color: transparent;
        }
        &:hover {
          color: #6d2ef8;
        }
        &.is-active {
          color: #6d2ef8;
          font-weight: 700;
          &::after {
            background-color: #6d2ef8;
          }
        }
      }
    }
    .dropdown-box {
      display: flex;
      align-items: flex-end;
      width: 60px;
      .el-drowdown {
        width: 100%;
      }
      .el-dropdown-link {
        font-size: 12px;
        color: #333333;
        line-height: 28px;
        display: block;
        height: 28px;
        width: 100%;
        margin-bottom: 1px;
        border-bottom: 1px solid #DCDAE2;
      }
    }
    .el-dropdown {
      width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// src/layout/components/common-module-list/index.vue